import { render, staticRenderFns } from "./ClientAddHandler.vue?vue&type=template&id=45c7e501&scoped=true&"
import script from "./ClientAddHandler.vue?vue&type=script&lang=js&"
export * from "./ClientAddHandler.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddHandler.vue?vue&type=style&index=0&id=45c7e501&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7e501",
  null
  
)

export default component.exports